import { render, staticRenderFns } from "./card-list.vue?vue&type=template&id=3b6863b6&scoped=true&"
import script from "./card-list.vue?vue&type=script&lang=ts&"
export * from "./card-list.vue?vue&type=script&lang=ts&"
import style0 from "./card-list.vue?vue&type=style&index=0&id=3b6863b6&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b6863b6",
  null
  
)

export default component.exports